import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
// import Ads from "components/ad/index.js";
import Head from "next/head";
// import Link from "next/link";
import { FormattedMessage } from "react-intl";
import { getLanguage } from "localization/i8intl";
import { NextSeo } from "next-seo";
import { metaTags } from "../../../constants/metaTags";
import { useWindowSize } from "api/commonConstants";

const ContactUs = () => {
  const [language, setLanguage] = useState("");
  const size = useWindowSize();
  const [firstScroll, setFirstScroll] = useState(false);

  useEffect(() => {
    setLanguage(getLanguage());

    async function onFirstScroll() {
      if (!firstScroll) {
        setFirstScroll(true);
        setTimeout(() => {
          window.googletag = window.googletag || { cmd: [] };
          googletag.cmd.push(function () {
           
            googletag
              .defineSlot(
                "/1007232/Lallantop_Desktop_ROS_ATF_728x90",
                [
                  [728, 90],
                  [970, 250],
                  [970, 90],
                ],
                "div-gpt-ad-1701945163318-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/Lallantop_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1701945220410-1"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/Lallantop_Mobile_ROS_ATF_300x250",
                [
                  [336, 280],
                  [300, 250],
                ],
                "div-gpt-ad-1701946028239-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/Lallantop_Mobile_ROS_MTF_1_300x250",
                [
                  [336, 280],
                  [300, 250],
                ],
                "div-gpt-ad-1701946028239-1"
              )
              .addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", [""]);
            googletag.pubads().setTargeting("Keywords", "");
            googletag.enableServices();
          });
          // apstag.init({
          //   pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
          //   adServer: "googletag",
          //   bidTimeout: 2e3,
          // });
          // // request the bids for the four googletag slots
          // apstag.fetchBids(
          //   {
          //     slots: [],
          //   },
          //   function (bids) {
          //     // set apstag bids, then trigger the first request to GAM
          //     googletag.cmd.push(function () {
          //       apstag.setDisplayBids();
          //       googletag.pubads().refresh();
          //     });
          //   }
          // );
          googletag.pubads().refresh();

        });
      }
    }
    function handleScroll() {
      onFirstScroll();
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);
  }, []);
  const cateogry = "factcheck";
  const key = "FactCheck,TheLallantop";
  return (
    <>
      <Head>
        {/* <script
          dangerouslySetInnerHTML={{
            __html: `
window.googletag = window.googletag || {cmd: []};
googletag.cmd.push(function() {
  var mapping = googletag.sizeMapping().
				addSize([4000, 0], [[728, 90], [970, 90], [970, 250]]).
				addSize([3000, 0], [[728, 90], [970, 90], [970, 250]]).
				addSize([2000, 0], [[728, 90], [970, 90], [970, 250]]).
				addSize([1000, 0], [[728, 90], [970, 90], [970, 250]]).
				addSize([750, 0], [728, 90]).
				addSize([700, 0], [[300, 250],[336, 280]]).
				addSize([530, 0], [[300, 250],[336, 280]]).
				addSize([336, 0], [[300, 250],[336, 280]]).
				addSize([320, 0], [300, 250]).
				addSize([0, 0], [300, 250]).build();
	var mapping1 = googletag.sizeMapping().
				addSize([4000, 0], [728, 90]).
				addSize([3000, 0], [728, 90]).
				addSize([2000, 0], [728, 90]).
				addSize([1000, 0], [728, 90]).
				addSize([750, 0], [728, 90]).
				addSize([700, 0], [[300, 250],[336, 280]]).
				addSize([530, 0], [[300, 250],[336, 280]]).
				addSize([336, 0], [[300, 250],[336, 280]]).
				addSize([320, 0], [300, 250]).
				addSize([0, 0], [300, 250]).build();
	var mapping2 = googletag.sizeMapping().
				addSize([4000, 0], [728, 90]).
				addSize([3000, 0], [728, 90]).
				addSize([2000, 0], [728, 90]).
				addSize([1000, 0], [728, 90]).
				addSize([750, 0], [728, 90]).
				addSize([700, 0], [[300, 250],[300, 100],[320, 100]]).
				addSize([530, 0], [[300, 250],[300, 100],[320, 100]]).
				addSize([336, 0], [[300, 250],[300, 100],[320, 100]]).
				addSize([320, 0], [300, 250]).
				addSize([0, 0], [300, 250]).build();
var REFRESH_KEY = 'refresh';
var REFRESH_VALUE = 'true';
googletag.pubads().setTargeting('Category', ['']);
googletag.pubads().setTargeting('Keywords', '');
var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
googletag.pubads().addEventListener('impressionViewable', function(event) {
var slot = event.slot;
if (slot.getTargeting(REFRESH_KEY).indexOf(REFRESH_VALUE) > -1) {
setTimeout(function() {
googletag.pubads().refresh([slot]);
}, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
}
});
    googletag.pubads().enableSingleRequest();
    googletag.enableServices();
  });`,
          }}
        ></script>
        <script
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `
  apstag.init({
    pubID: '7f0bbd82-5a13-48ec-9950-fcb028b1546c',
    adServer: 'googletag',
    bidTimeout: 2e3
  });
  // request the bids for the four googletag slots
  
  }, function(bids) {
    // set apstag bids, then trigger the first request to GAM
    googletag.cmd.push(function() {
      apstag.setDisplayBids();
      googletag.pubads().refresh();    
    });
  });`,
          }}
        ></script> */}
      </Head>
      <NextSeo
        title={metaTags["factcheck"]["contactUs"].metaTitle}
        description={metaTags["factcheck"]["contactUs"].metaDescription}
      />
      <div className="content-wrapper">
        <Container align="center">
          <div className="container-row py-2" align="center">
            <p
              style={{
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
              }}
            >
              Advertisement
            </p>
            <div
              id={
                size.width > 600
                  ? "div-gpt-ad-1701945163318-0"
                  : "div-gpt-ad-1701946028239-0"
              }
              style={{
                minWidth: "300px",
                minHeight: size.width > 600 ?  "100px" : "260px",
                display: "block !important",
                alignContent:"center",textAlign:"-webkit-center"
              }}
            >
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html:
                    size.width > 600
                      ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1686741281219-0')})`
                      : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})`,
                }}
              ></script>
            </div>
          </div>
        </Container>
        <div className="outer-container-info-page">
          <div className="backlink-bar terms-title">
            <a href="/all/factcheck">
              <a
              // onClick={() => {
              //   ClevertapReact.event("header_back_click");
              //   router.back();
              // }}
              >
                <i className="icon-back-arrow"></i>
              </a>
            </a>
            <h2>
              <FormattedMessage id="fact_check" defaultMessage="पड़ताल" />
            </h2>
          </div>
          <h1>{language === "hi" ? "हमारा पता-ठिकाना" : "Contact Us"}</h1>
          <p>
            आप वायरल हो रहे दावे और पड़ताल का फीडबैक हमें मेल और सोशल मीडिया के
            ज़रिए पहुंचा सकते हैं.
          </p>
          <div className="contact-us-row outside-row">
            <div className="contact-us-image gps-icon">
              <img
                src="/assets/images/map-location-pointer.png"
                alt="gps-icon"
              />
            </div>
            <div>
              <div>Editor</div>
              <div>The Lallantop FC8</div>
              <div> Film City, Sector 16A</div>
              <div>Noida Uttar Pradesh</div>
            </div>
          </div>
          <p>ईमेल करें</p>
          <div className="contact-us-row outside-row">
            <div className="contact-us-image">
              <img src="/assets/images/mail-padtaal.png" alt="mail-icon" />
            </div>
            <a
              href="mailto:padtaal@lallantop.com"
              style={{ marginBottom: "2.5rem" }}
            >
              padtaal@lallantop.com
            </a>
          </div>
          <p>वॉट्सऐप</p>

          <div className="contact-us-row outside-row">
            <div className="contact-us-image">
              <img
                src="/assets/images/whatsapp-padtaal1.png"
                alt="image-icon"
              />
            </div>
            <a href="https://wa.me/919899813111?text=Hi%2C%20Padtaal">
              Padtaal Whatsapp Helpline
            </a>
          </div>
          <p>सोशल मीडिया पर पड़ताल</p>
          <div className="contact-us">
            <div className="contact-us-row">
              <div className="contact-us-image">
                <img
                  src="/assets/images/facebook-padtaal1.png"
                  alt="facebook-icon"
                />
              </div>
              <a href="https://www.facebook.com/Padtaal.LT"> Padtaal.LT</a>
            </div>
            <div className="contact-us-row">
              <div className="contact-us-image">
                <img
                  src="/assets/images/twitter-padtaal1.png"
                  alt="twitter-icon"
                />
              </div>
              <a href="https://twitter.com/padtaal_LT"> Padtaal.LT</a>
            </div>
            <div className="contact-us-row">
              <div className="contact-us-image">
                <img
                  src="/assets/images/insta-padtaal1.png"
                  alt="instagram-icon"
                />
              </div>
              <a href="https://www.instagram.com/padtaal_LT/"> Padtaal.LT</a>
            </div>
            <div className="contact-us-row">
              <div className="contact-us-image">
                <img
                  src="/assets/images/telegram-padtaal1.png"
                  alt="telegram-icon"
                />
              </div>
              <a href="https://t.me/Padtaal"> Padtaal</a>
            </div>
            <div className="contact-us-row">
              <div className="contact-us-image">
                <img
                  src="/assets/images/youtube-padtaal1.png"
                  alt="youtube-icon"
                />
              </div>
              <a href="https://www.youtube.com/channel/UCErXvSkCrTK8y6nU-SCg6nQ">
                Padtaal
              </a>
            </div>
          </div>
          <p style={{ marginTop: "3rem" }}>
            ज़रूरी नहीं कि आपकी भेजी हर जानकारी फ़ेक न्यूज़ के दायरे में आती हो
            या फिर उसका फ़ैक्ट चेक संभव हो. लेकिन हम आपको प्रोत्साहित करते हैं
            कि किसी भी जानकारी पर शक हो तो हमें ज़रूर भेजें. कई बार बिल्कुल सही
            दिखने वाली जानकारी भी गलत हो सकती है. आप हम तक वायरल दावे पहुंचाने
            के लिए ऊपर दिए पड़ताल के किसी भी सोशल मीडिया हैंडल का इस्तेमाल कर
            सकते हैं.
          </p>
        </div>
        <Container align="center">
          <div className="container-row py-2" align="center">
            <p
              style={{
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
              }}
            >
              Advertisement
            </p>
            <div
              id={
                size.width > 600
                  ? "div-gpt-ad-1701945220410-1"
                  : "div-gpt-ad-1701946028239-1"
              }
              style={{
                minWidth: "300px",
                minHeight: size.width > 600 ? "100px" : "260px",
                display: "block !important",
                alignContent:"center",textAlign:"-webkit-center"
              }}
            >
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html:
                    size.width > 600
                      ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})`
                      : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})`,
                }}
              ></script>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ContactUs;
